import React, { useCallback, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'

import { strings } from '@constants'
import { addGstToOrganisation } from '@data'
import OrgGstDetail from '@data/model/NewModals/OrgGstDetail'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { DrawerBodyWrapper, DrawerFooterWrapper, TOAST_TYPE } from '@base'
import { Button, Input } from '@baseV2'
import AddAddress from '@pages/Admin/OrgsAndUsers/Organisation/DrawerComponents/AddAddress'
import { InputsWrapper } from '../styles'

const GST_REGEX = /^\d{2}[A-Z]{5}\d{4}[A-Z][A-Z\d][Z][A-Z\d]$/

const AddGst = ({ orgId, update }) => {
	const dispatch = useDispatch()
	const [gst, setGst] = useState('')
	const [touched, setTouched] = useState(false)
	const [address, setAddress] = useState({})
	const [addressReady, setAddressReady] = useState(false)

	const isGstValid = useMemo(() => GST_REGEX.test(gst), [gst])
	const gstError = touched && gst && !isGstValid ? strings('enter_digit_gstin') : ''

	const addressCb = useCallback(({ address: addr, enableButton }) => {
		if (addr) setAddress(addr)
		if (enableButton !== undefined) setAddressReady(enableButton)
	}, [])

	const handleGstChange = (e) => {
		setGst((e.target.value ?? '').toUpperCase())
		if (!touched) setTouched(true)
	}

	const submit = () => {
		if (!isGstValid || !addressReady) return
		dispatch(showLoader(true))
		const gstDetail = new OrgGstDetail().update({ address, gst })
		addGstToOrganisation(gstDetail.toJS(), orgId)
			.then(() => {
				dispatch(showToast(true, 'Successfully added new GST details', { type: TOAST_TYPE.SUCCESS }))
				dispatch(toggleDrawer(false))
				update?.()
			})
			.catch((err) => {
				console.log(err)
				dispatch(showToast(true, 'Error while adding new gst details', { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => dispatch(showLoader(false)))
	}

	return (
		<>
			<DrawerBodyWrapper>
				<InputsWrapper>
					<Input
						label={strings('gstin')}
						id='org-gstin-v2'
						value={gst}
						onChange={handleGstChange}
						onBlur={() => setTouched(true)}
						placeholder={strings('digit_gstin')}
						error={gstError}
					/>
					<AddAddress addressCb={addressCb} />
				</InputsWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button color='primary' disabled={!isGstValid || !addressReady} onClick={submit}>
					{strings('add', 'details')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default AddGst
